import {BasePanelPage} from "../../PanelPage";

// TODO @branch this should not exist, it seems to be used when there isn't anything
export class PanelCollapsed extends BasePanelPage {
    getChildrenToRender() {
        return [];
    }
}
